import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobs } from "../../features/jobs/jobsSlice";
import Loader from "../ui/Loader";
import JobItem from "./JobItem";

const JobList = () => {
  const dispatch = useDispatch();
  const { jobs, status, query } = useSelector((state) => state.jobs);

  useEffect(() => {
    dispatch(fetchJobs("All"));
  }, [dispatch]);

  const filteredJobs = useMemo(() => {
    return jobs.filter((item) => {
      return item.title.toLowerCase().includes(query.toLowerCase());
    });
  }, [jobs, query]);

  if (status === "loading") {
    return <Loader />;
  }

  return (
    <div className="jobs-list">
      {filteredJobs?.map((job) => (
        <JobItem key={job.id} job={job} />
      ))}
    </div>
  );
};

export default JobList;
